"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormFieldsColumn = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const FormFieldsColumn = props => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "fields-column bx--col-lg-8 bx--col-md-4 bx--col-sm-4"
  }, props.children);
};
exports.FormFieldsColumn = FormFieldsColumn;